<template>
  <div class="backgroud-white cs-homework-editor">
    <div class="text-center">
      <h6 style="font-size:border">{{ isAdded?'添加新作业': '编辑作业'}}</h6>
    </div>
    <div class="popup-content-area-small">
      <el-form
        ref="model"
        :rules="rules"
        :model="model"
        label-width="100px"
      >
        <el-form-item label="课程" prop="courseName">
          <span>{{ model.courseName }}</span>
        </el-form-item>
        <el-form-item label="作业名称" prop="name">
          <el-input
            @change="checkAllInputs"
            placeholder="请填写作业名称"
            v-model="model.name"
            class="input-width"
          ></el-input>
        </el-form-item>
            <el-form-item label="完成要求" prop="homeworkType">
          <el-select
            @change="onHomeworkTypeChange"
            v-model="model.homeworkType"
            placeholder="请选择是否要求学生完成"
          >
            <el-option
              v-for="(item, index) in homeworkTypes"
              :key="index"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="对应课节" prop="courseActivationId">
          <el-select
            @change="checkAllInputs"
            v-model="model.courseActivationId"
            placeholder="请选择对应课节"
            :loading="isLoadingCourseActivations"
          >
            <el-option
              v-for="(item, index) in courseActivations"
              :key="index"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="周" prop="week">
          <el-select
            @change="checkAllInputs"
            v-model="model.week"
            placeholder="请选择对应课节"
            :loading="isLoadingWeeks"
          >
            <el-option
              v-for="(item, index) in weekList"
              :key="index"
              :label="item.Label"
              :value="item.Week"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="截止时间" prop="endTime">
          <el-date-picker
            align="center"
            @change="checkAllInputs"
            format="yyyy/MM/dd hh:mm A"
            v-model="model.endTime"
            type="datetime"
            placeholder="请选择作业递交截止时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上传文件" prop="value">
          <ul class="el-upload-list el-upload-list--text">
            <li
              v-for="(item, itemIndex) in model.files"
              :key="itemIndex"
              class="el-upload-list__item is-success"
            >
              <a class="el-upload-list__item-name">
                {{item.FileName}}
                <a @click="removeFile(item)" style="color:red;">删除</a>
              </a>
            </li>
          </ul>
          <el-button type="primary" @click="uploadHomeworkFile()">添加文件</el-button>
        </el-form-item>
        <el-dialog
          center
          title="上传作业"
          :show-close="true"
          :close-on-click-modal="false"
          width="700px"
          :visible.sync="homeworkUploaderVisible"
          top="8vh"
          z-index="2000"
        >
          <blobUploader
            @closeEditor="onCloseHomeworkUploader"
            @blobUploadError="onHomeworkUploadError"
            @blobUploaded="onHomeworkUploaded"
            :type="8"
            :accepts="'.png,.jpg,.jpeg,.txt,.pdf,.doc,.docx,.xls,.xlsx,.csv,.html,.css,.js,.zip,.py,.c,.cc,.cpp,.rmd,.rkt,.zip,.rar'"
            :maxNameLength="32"
            :isVisible="homeworkUploaderVisible"
            :isMulti="true"
            :isAutoSave="true"
          ></blobUploader>
        </el-dialog>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer" v-if="!isReadonly">
      <el-row>
        <el-col :span="24" class="text-center">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="text-center" :span="24">
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >{{ isAdded?'确认添加': '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-homework-editor {
  color: black;
  h6 {
    font-weight: bold;
  }
  /deep/ .el-form-item__label {
    color: black;
    line-height: 40px;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>

<script>
import {
  getCourseActivations,
  saveHomework
} from "../../service/homework.service";
import { getWeekListByCourseId } from "@/service/termManage.service";
import blobUploader from "@/components/fileHandler/blobUploader";
let moment = require("moment");

export default {
  props: {
    data: {},
    dialogVisible: false
  },
  data() {
    return {
      model: {
        id: 0,
        name: "",
        courseId: 0,
        //courseActivationId: 0,
        homeworkType: 1,
        week: 1,
        endTime: "",
        EndTimeString: "",
        files: []
      },
      homeworkTypes: [
        { Key: 1, Value: "要求完成" },
        { Key: 2, Value: "练习" }
      ],
      weekList:[],
      isLoadingWeeks: false,
      //courseActivations: {},
      //isLoadingCourseActivations: false,
      homeworkUploaderVisible: false,
      isReadonly: false,
      submitBtnClass: "info",
      submitBtnDisable: false,
      isAdded: false,
      showError: false,
      errorMessage: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入作业名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 250,
            message: "最大长度在为250个字符",
            trigger: "blur"
          }
        ],
        week:[
          {
            required: true,
            message: "请选择周",
            trigger: "blur"
          }
        ]
        // courseActivationId: [
        //   {
        //     required: true,
        //     message: "请选择课节",
        //     trigger: "blur"
        //   }
        // ]
      }
    };
  },
  components: {
    blobUploader
  },
  created() {
    this.loadData();
  },
  methods: {
    // loadCourseActivationsData(){
    //   this.isLoadingCourseActivations = true;
    //   getCourseActivations(
    //     this.model.id,
    //     this.model.courseId,
    //     this.model.campusId,
    //     this.model.homeworkType
    //   ).then(result => {
    //     if (!!result && result.success) {
    //       this.courseActivations = result.data;
    //       let index = this.courseActivations.findIndex(i => i.Key == this.model.courseActivationId);
    //       if (index < 0){
    //         this.model.courseActivationId = "";
    //       }
    //     }else{
    //       this.courseActivations = [];
    //     }
    //     this.isLoadingCourseActivations = false;
    //   }).catch(()=>{
    //     this.courseActivations= [];
    //     this.isLoadingCourseActivations = false;
    //   });
    // },
    loadWeekList(){
      this.isLoadingWeeks = true;
      getWeekListByCourseId(this.data.CourseId, false, true).then(result =>{
        if (result && result.success){
          this.weekList = result.data;
          if (this.isAdded && this.weekList.length > 0){
            this.week = this.weekList[0].Week;
          }
        }
        this.isLoadingWeeks = false;
      }).catch(()=>{
        this.weekList = [];
        this.isLoadingWeeks = false;
      });
    },
    onHomeworkTypeChange(){
      //this.loadCourseActivationsData();
      this.checkAllInputs();
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.model.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (this.model.homeworkType == 1) {
        if (!this.model.endTime) {
          isValid = false;
        }
      }
      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }
    },
    save() {
      if (!!this.$refs["model"]) {
        let isValid = true;
        this.$refs["model"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }

        if (!!this.model.endTime){
          this.model.EndTimeString = moment(this.model.endTime).format("YYYY/MM/DD hh:mm A");
        }
        
        this.submitBtnDisable = true;
        let result = saveHomework(this.model).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message("保存成功！");
            this.showError = false;
            this.$emit("saveSuccess", this.isAdded, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
        });
      }
    },
    removeFile(file) {
      var index = this.model.files.findIndex(item => {
        if (item.Id == file.Id) {
          return true;
        }
      });
      this.model.files.splice(index, 1);
      this.checkAllInputs();
    },
    close() {
      this.$emit("closeDialog");
    },
    loadData() {
      if (!!this.data && !!this.data.Id) {
        this.isAdded = false;
        this.model.id = this.data.Id;
        this.model.name = this.data.Name;
        this.model.campusId = this.data.CampusId;
        this.model.courseId = this.data.CourseId;
        this.model.courseName = this.data.CourseName;
        this.model.week = this.data.Week;
        //this.model.courseActivationId = this.data.CourseActivationId;
        this.model.homeworkType = this.data.HomeworkType;
        this.model.endTime = this.data.EndTimeString;
        this.model.files = this.data.Files;
        this.submitBtnClass = "primary";
      } else {
        this.isAdded = true;
        this.model.id = 0;
        this.model.name = "";
        this.model.campusId = this.data.CampusId;
        this.model.courseName = this.data.CourseName;
        this.model.courseId = this.data.CourseId;
        this.model.homeworkType = 1;
        this.model.week = "";
        //this.model.courseActivationId = "";
        this.model.endTime = "";
        this.submitBtnClass = "info";
        this.model.files = [];
      }
      this.loadWeekList();
      //this.loadCourseActivationsData();
    },
    closeHomeworkUploader() {
      this.homeworkUploaderVisible = false;
      this.currentUploadHomework = null;
    },
    uploadHomeworkFile() {
      this.homeworkUploaderVisible = true;
    },
    onHomeworkUploaded(data) {
      if (!!data) {
        data.forEach(item => {
          this.model.files.push({
            Id: item.FileId,
            FileName: item.FileName
          });
        });
        this.checkAllInputs();
      }
      this.homeworkUploaderVisible = false;
    },
    onHomeworkUploadError() {},
    onCloseHomeworkUploader() {}
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/homeworkEditor.vue